<div #mapContainer class="relative h-full w-full overflow-hidden">
  <div #mapElement class="h-full w-full"></div>

  <!--
    Mapbox puts its own controls top-right, so the panels take the free corner. Both can
    claim it because only one can ever run: a session is begun by the geometry field of the
    entity being edited, and an entity carries either a boundary or a polyline, never both.
  -->
  @if (editSession.isActive()) {
    <div class="absolute top-2 left-2 z-10">
      <app-geo-area-edit-panel />
    </div>
  }
  @if (arcSession.isActive()) {
    <div class="absolute top-2 left-2 z-10">
      <app-geo-arc-edit-panel />
    </div>
  }
</div>
